<template>
  <div class="w-full">
    <vs-button
      color="#3498DB"
      type="filled"
      @click="open"
      icon-pack="feather"
      icon="icon-file-text"
      class="w-full"
      :disabled="disabled"
    >
      {{ $t('show_files') | capitalize }}
    </vs-button>
    <vs-popup :title="title" :active.sync="popupActive" id="expense-pdf-viewer" @keyup.esc="popupActive = false">
      <div id="expense-pdf-viewer-loading" class="vs-con-loading__container">
        <vs-tabs v-if="files.length > 0">
          <vs-tab
            :label="index === 0 ? file.name : $t('other')"
            v-for="(file, index) in files"
            :key="index"
          >
            <div class="tab-text">
              <iframe
                :src="file.pdf"
                class="w-full show-pdf"
                :style="{ height: '70vh' }"
              ></iframe>
            </div>
            <vs-button
              v-if="index !== 0 && hasPermission(['IU ACCOUNTING EDIT'])"
              icon-pack="feather"
              icon="icon-trash"
              class="btn-flotante icon-scale"
              @click="confirmDelete(file)"
            ></vs-button>
          </vs-tab>
        </vs-tabs>
        <div v-else style="height:400px">

        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { BASE_URL } from '@/urls.js'
import expense from '@/http/requests/expense'
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'

export default {
  components: {
    VsPopupCustom,
  },
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expense: {
      type: String,
    },
  },
  data() {
    return {
      dialog: false,
      popupActive: false,
      file:{},
      files: [],
      loading: {
        delete: false,
        files: false,
      },
    }
  },
  computed: {
    isLoading() {
      return this.loading.delete || this.loading.files
    },
  },
  methods: {
    open() {
      this.files=[]
      this.popupActive = true
      this.getFiles()
    },
    getName(url) {
      return url.substring(url.lastIndexOf('/') + 1)
    },
    getFiles() {
      this.loading.files = true
      expense
        .getFiles({ expense_id: this.expense })
        .then((res) => {
          this.files = res.data.files
          this.loading.files = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading.files = false
        })
    },
    confirmDelete(file) {
      this.file = file
     this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm_delete,
        text: this.$i18n.messages[this.$i18n.locale].delete_message_confirm,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deteleFile
      })
    },
    deteleFile() {
      this.loading.delete = true
      this.files = [] 
      expense
        .deleteFile(this.file)
        .then((res) => {
          this.getFiles()
          this.loading.delete = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading.delete = false
        })
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('expense-pdf-viewer-loading')
      } else {
        this.closeLoading('expense-pdf-viewer-loading')
      }
    },
  },
  mixins: [loading],
  mounted() {
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
         this.popupActive = false
      }
    })
  },
  watch:{
    popupActive(val){
        setTimeout( () => {
          this.$store.dispatch('setPopup',val)
        },500)
    }
  }
}
</script>
<style>
/* 1366 x 768 */
.show-pdf {
  display: block;
  border: none;
}

#expense-pdf-viewer > div.vs-popup {
  width: calc(100% - 30px) !important;
}

.btn-flotante {
  position: fixed;
  top: 32px;
  right: 44px;
  transition: all 300ms ease 0ms;
  z-index: 99;
  font-size: 1.25em;
  
}
.btn-flotante:hover {
  transform: translate(-2px,2px);
}

.btn-flotante.includeIconOnly {
    width: 32px!important;
    height: 32px!important;
}
</style>
